<div>
  <div class="placeholder" [class.out]="displayText">
    <div class="placeholder-line"></div>
    <div class="placeholder-line"></div>
    <div class="placeholder-line"></div>
  </div>
  <p #paragraph [innerHTML]="displayText"></p>
</div>
